module.exports = __webpack_public_path__ + "assets/img/Kampanye.9e538995.png";